// @ts-nocheck

import { createSelector } from 'reselect';

import { GRNotificationTypes } from '../../types/notification';
import { selectGRMiscCurrentNotification, selectGRMiscTmpNotifications } from '../misc';
import { selectGRUserRoundId } from '../user';

const selectGRRoundCompleteNotification = createSelector(
  [selectGRMiscCurrentNotification, selectGRMiscTmpNotifications],
  (currentNotif, notifications) =>
    currentNotif && currentNotif.type === GRNotificationTypes.ROUND_COMPLETE && notifications.length === 1
      ? currentNotif
      : null,
);

export const selectShowGRRoundCompleteNotification = createSelector(
  [selectGRRoundCompleteNotification],
  (notif) => !!notif,
);

const selectBaseFreebetsAmount = createSelector(
  [selectGRRoundCompleteNotification],
  (notif) => notif?.data?.baseAmount,
);

const selectBonusCoeff = createSelector([selectGRRoundCompleteNotification], (notif) => notif?.data?.bonusCoefficient);

const selectTotalFreebetsAmount = createSelector(
  [selectGRRoundCompleteNotification],
  (notif) => notif?.data?.totalAmount,
);

const selectNotificationId = createSelector([selectGRRoundCompleteNotification], (notif) => notif?.uuid);

const selectGRRoundCompleteNotificationProps = createSelector(
  [
    selectShowGRRoundCompleteNotification,
    selectBaseFreebetsAmount,
    selectBonusCoeff,
    selectTotalFreebetsAmount,
    selectGRUserRoundId,
    selectNotificationId,
  ],
  (show, baseFreebetsAmount, multiplicator, totalFreebetsAmount, roundId, notificationId) => ({
    show,
    baseFreebetsAmount,
    multiplicator,
    totalFreebetsAmount,
    roundId,
    notificationId,
  }),
);

export default selectGRRoundCompleteNotificationProps;
